export const GLOBAL_INTERESTS_FILTERS = 'GLOBAL_INTERESTS_FILTERS';
export const INTEREST_SUMMARY = 'INTEREST_SUMMARY';
export const INTEREST_ITEMS = 'INTEREST_ITEMS';
export const CUSTOMER_APPROVAL = 'CUSTOMER_APPROVAL';
export const ADD_COMPANY = 'ADD_COMPANY';